import htmlParse from "html-react-parser";

import _isNil from "lodash/isNil";
import { PRIMARY_COLOR } from "./constants";

export const parse = (text) => {
  text = text.replaceAll(
    "<highlight>",
    `<span style="color:${PRIMARY_COLOR};">`,
  );
  text = text.replaceAll("</highlight>", "</span>");

  text = text.replaceAll("<no_wrap>", '<span style="white-space: nowrap;">');

  text = text.replaceAll("</no_wrap>", "</span>");

  return htmlParse(text);
};

// True when build/index.html shipped prerendered markup (scripts/prerender.js).
// Read at import time, before React replaces the markup.
export const IS_PRERENDERED = Boolean(
  document.getElementById("root")?.hasChildNodes(),
);

export const isMobile = () => {
  return window.innerWidth < 750;
};

export const mobileDesktopSwitcher = ({ mobile, desktop }) => {
  return isMobile() ? mobile : desktop;
};

const scroll_element = (
  element,
  scrollAmount,
  time,
  discretization,
  scrollValues,
  final_value,
  count = 0,
) => {
  setTimeout(() => {
    if (!_isNil(scrollValues[count])) {
      element.scrollTop = scrollValues[count];
    }

    if (count < discretization - 1) {
      scroll_element(
        element,
        scrollAmount,
        time,
        discretization,
        scrollValues,
        final_value,
        count + 1,
      );
    } else {
      element.scrollTop = final_value;
    }
  }, time / discretization);
};

export const scrollParentToChild = (parent, child, time, discretization) => {
  // Where is the parent on page
  var parentRect = parent.getBoundingClientRect();
  // What can you see?
  var parentViewableArea = {
    height: parent.clientHeight,
    width: parent.clientWidth,
  };

  // Where is the child
  var childRect = child.getBoundingClientRect();
  // Is the child viewable?
  var isViewable =
    childRect.top >= parentRect.top &&
    childRect.bottom <= parentRect.top + parentViewableArea.height;

  var scrollAmount = 0;
  // if you can't see the child try to scroll parent
  if (!isViewable) {
    // Should we scroll using top or bottom? Find the smaller ABS adjustment
    const scrollTop = childRect.top - parentRect.top;
    const scrollBot = childRect.bottom - parentRect.bottom;
    if (Math.abs(scrollTop) < Math.abs(scrollBot)) {
      // we're near the top of the list
      scrollAmount = scrollTop - 20;
    } else {
      // we're near the bottom of the list
      scrollAmount = scrollBot + 20;
    }
  }

  if (scrollAmount === 0) return;
  var scrollValues = [];

  for (let i = 0; i < discretization; i++) {
    var scrollValue;
    if (i === 0) {
      scrollValue = parent.scrollTop + scrollAmount / discretization;
    } else {
      scrollValue = scrollValues[i - 1] + scrollAmount / discretization;
    }

    scrollValues.push(scrollValue);
  }
  scroll_element(
    parent,
    scrollAmount,
    time,
    discretization,
    scrollValues,
    parent.scrollTop + scrollAmount,
  );
};
